import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const TemporaryNotice = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  // Check if today is 2026. március 21.
  const now = new Date();
  const targetDate = new Date('2026-03-21');
  
  // Compare dates (ignore time)
  const isTargetDate = 
    now.getFullYear() === targetDate.getFullYear() &&
    now.getMonth() === targetDate.getMonth() &&
    now.getDate() === targetDate.getDate();

  // Don't show if not target date or if dismissed
  if (!isTargetDate || isDismissed) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-yellow-50 to-amber-50 border-b-4 border-amber-500 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-start space-x-4">
          <AlertTriangle className="w-8 h-8 text-amber-600 flex-shrink-0 mt-1" />
          <div className="flex-1">
            <p className="text-lg font-bold text-amber-900">
              Figyelem! 2026. március 21-én (szombaton) a házhozszállítás nem elérhető.
            </p>
            <p className="text-amber-800 mt-1">
              Kérjük, rendeléshez hívjon minket telefonon, vagy válassza a helyszíni fogyasztást vagy az elvitelt.
            </p>
            <a
              href="tel:+36309517159"
              className="inline-block mt-3 px-4 py-2 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition-colors"
            >
              📞 Telefonos rendelés: +36 30 951 7159
            </a>
          </div>
          <button
            onClick={() => setIsDismissed(true)}
            className="flex-shrink-0 p-1 hover:bg-amber-200 rounded-lg transition-colors"
            aria-label="Bezárás"
          >
            <X className="w-6 h-6 text-amber-700" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemporaryNotice;
